import { createFileRoute, redirect } from '@tanstack/react-router'
import * as v from 'valibot'

import { hasPermissions } from '@/access-control/hasPermissions'
import keycloak from '@/core/keycloak'
import { usersQueries } from '@/http/api/users'
import SignupPoll from '@/signup/components/SignupPoll'

const pollSearchSchema = v.object({
  step: v.fallback(v.optional(v.number()), 0),
})

export const Route = createFileRoute('/signup/poll')({
  beforeLoad: async ({ context: { queryClient } }) => {
    if (!keycloak.authenticated) {
      throw redirect({ href: keycloak.createLoginUrl() })
    }

    const user = await queryClient.ensureQueryData(
      usersQueries.usersCurrentDetails(),
    )
    if (!user) {
      throw Error('User not found')
    }

    const canAccessLearningSpace = hasPermissions(user, {
      to: 'access-learning',
    })
    const canAccessCompanySpace = hasPermissions(user, { to: 'access-company' })

    if (!canAccessLearningSpace && canAccessCompanySpace) {
      throw redirect({ to: '/company' })
    }
  },
  validateSearch: pollSearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return <SignupPoll />
}
